module.exports = __webpack_public_path__ + "5befa904cae04fd033d3f5e32ac7eb4e.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/wasistgoldencity2.jpg
// module id = 502
// module chunks = 0